import { Link } from 'react-router-dom';

const ITEMS = [
  {
    q: '免费51漫画上的漫画都可以免费看吗？',
    a: '是的，站内大部分作品都支持免费在线观看。你可以按标签筛选找到想看的漫画，直接进入详情页阅读。',
  },
  {
    q: '如何快速找到我想看的漫画类型？',
    a: '首页提供热血类、搞笑类、少女漫、少年漫、完结作品、汉化组等六大标签，点击对应标签即可进入分类页查看该类型全部作品。',
  },
  {
    q: '连载中的漫画多久更新一次？',
    a: '不同作品更新频率不同，多数连载漫画每周更新 1-2 话，部分热门作品每日更新。请在作品详情页查看更新说明。',
  },
  {
    q: '追更的漫画会不会突然中断？',
    a: '我们会尽量保证更新稳定。若某部作品因汉化组或版权原因暂时停更，会在详情页标注，避免读者空等。',
  },
];

export default function FaqPreview() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-sm font-semibold uppercase tracking-widest text-primary-600">Help Center</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              常见问题
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              关于免费观看、标签筛选与更新频率的疑问，这里都有答案。
            </p>
          </div>
          <Link
            to="/faq"
            className="whitespace-nowrap rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            查看全部 FAQ
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {ITEMS.map((item) => (
            <div
              key={item.q}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-start gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-sm text-accent-800">
                  <i className="ri-question-line"></i>
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-900">{item.q}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}